module.exports = __webpack_public_path__ + "img/10004.f87d1264.jpg";